<div class="mini-cart"
     [attr.data-test]="'shared-miniCart'"
     [ngClass]="{'is-open': isOpen, 'alert alert--success': showNewItemAddedNotification}">
  @if (!isMinicartAccessible()) {
    <div class="mini-cart__content">
      <div class="mini-cart__no-access">
        <app-access-control [description]="true">
        </app-access-control>
      </div>
    </div>
  }
  @if (isMinicartAccessible()) {
    <div class="mini-cart__content">
      @if (showNewItemAddedNotification) {
        <div class="mini-cart__header">
          <div class="mini-cart__indicator">
            <span class="icon alert__indicator" aria-hidden="true"></span>
            <h5 class="mini-cart__title" id="addedToCartAlertTitle">
              {{ 'shop-cart.item-added-title' | translate }}
            </h5>
          </div>
          @if (isLastAddedItemLoaded) {
            <p class="mini-cart-item-name" [attr.data-test]="'itemAddedMessage'">
              {{ 'mini-cart.item-added-message' | translate: {name: itemName} }}
            </p>
          }
        </div>
      }
      <div class="mini-cart__body">
        @if (isContractInCart()) {
          <app-configurable-mini-cart
              [currency]="currency"
              [currentCartId]="currentCart?.id"
              [currentCartName]="currentCartName"
              [usersCarts]="usersCarts"
              [itemsInCart]="itemsInCart"
              [hasNickname]="hasNickname"
              (showAddNicknameModal)="addNicknameModalActive = $event"
              (showDeleteQuoteModal)="deleteQuoteModalActive = $event"
              (closeMiniCart)="closeMiniCart()"
              (redirectToHomepage)="redirectToHomepageOnCartOperationFinish = true">
          </app-configurable-mini-cart>
        }
        @if (!isContractInCart()) {
          <app-multi-mini-cart
              [currency]="currency"
              [currentCartId]="currentCart?.id"
              [currentCartName]="currentCartName"
              [usersCarts]="usersCarts"
              [itemsInCart]="itemsInCart"
              [hasNickname]="hasNickname"
              [isApprover]="isApprover()"
              [checkWorkflowInformation]="checkWorkflowInformation()"
              [isExcludeTaxActive]="isExcludeTaxActive"
              (showAddNicknameModal)="addNicknameModalActive = $event"
              (showDeleteCartModal)="deleteCartModalActive = $event"
              (updateCartItemQuantity)="updateCartItemQuantity($event)"
              (closeMiniCart)="closeMiniCart()"
              (redirectToHomepage)="redirectToHomepageOnCartOperationFinish = true">
          </app-multi-mini-cart>
        }
      </div>
      @if (!isMinimumOrderValue()) {
        <div class="mini-cart__min-order-value">
          <strong>
            {{ 'shop-cart.minimum-order-value' | translate }}
          </strong>
        </div>
      }
      @if (!!totalPrice && checkWorkflowInformation()) {
        <div class="mini-cart__total">
          <div class="total-title">
            {{ 'mini-cart.total' | translate }}
            @if (showPriceDisclaimer) {
              <span [attr.data-test]="'desc-taxDisclaimer'">({{ 'shop-cart.excludes-vat' | translate }})</span>
            }
          </div>
          <div class="total-price" [attr.data-test]="'desc-minicartTotalPrice'">
            {{ totalPrice | currency:currency }}
            @if (isExcludeTaxActive) {
              <span class="tax-disclaimer" [attr.data-test]="'desc-taxDisclaimer'">
                ({{ 'app-product-page.ex_gst' | translate }})
              </span>
            }
          </div>
        </div>
      }
      @if (cartRules && cartRules?.length > 0 && !rfqActive) {
        <div class="mini-cart__discounts">
          <app-cart-rules [cartRules]="cartRules" [priceToPay]="priceToPay" [currency]="currency"></app-cart-rules>
        </div>
      }
      @if (itemsInCart?.length) {
        <div class="mini-cart__footer">
          <button type="button" class="button" (click)="closeMiniCart()" [attr.data-test]="'button-continueShopping'">
            {{ 'mini-cart.continue-shopping' | translate }}
          </button>
          <button type="button" class="button button--primary"
                  [routerLink]="['/shop-cart']"
                  (click)="closeMiniCart()"
                  [attr.data-test]="'button-goToCart'">
            {{ getLabelForCartButton() | translate }}
          </button>
        </div>
      } @else {
        <div class="mini-cart__no-items">
          <p class="message" [attr.data-test]="'cartIsEmptyMessage'">
            {{ 'shop-cart.empty-cart-message' | translate }}
          </p>
          <button type="button" class="button"
                  (click)="closeMiniCart()"
                  data-dismiss="alert"
                  [attr.data-test]="'button-continueShopping'">
            {{ 'mini-cart.continue-shopping' | translate }}
          </button>
        </div>
      }
      @if (isCartOperationInProgress) {
        <div class="loader__overlay">
          <span class="loading-animation"></span>
        </div>
      }
    </div>
  }
</div>
@if (currentCart) {
  <app-modal-add-cart-name
      [cartId]="currentCart.id"
      [hasNickname]="hasNickname"
      [newNameChange]="currentCartName$"
      [showAddNicknameModal]="addNicknameModalActive"
      [isContractInCart]="isContractInCart()"
      (closeModal)="addNicknameModalActive = false">
  </app-modal-add-cart-name>
}
<app-modal-confirm
    [type]="iconType.WARNING"
    [showModalConfirm]="deleteQuoteModalActive"
    [modalTitle]="'mini-cart.confirm-quote-delete-title' | translate"
    [notifyText]="'mini-cart.quote-delete-msg' | translate"
    [primaryBtnText]="'mini-cart.btn-delete' | translate"
    [cancelBtnText]="'mini-cart.btn-cancel' | translate"
    (primaryActionConfirm)="deleteQuote()"
    (closeModalConfirm)="deleteQuoteModalActive = false">
</app-modal-confirm>
<app-modal-confirm
    [type]="iconType.WARNING"
    [showModalConfirm]="deleteCartModalActive"
    [modalTitle]="'mini-cart.confirm-cart-delete-title' | translate"
    [notifyText]="'mini-cart.cart-delete-msg' | translate"
    [primaryBtnText]="'mini-cart.btn-delete' | translate"
    [cancelBtnText]="'mini-cart.btn-cancel' | translate"
    (primaryActionConfirm)="deleteCart()"
    (closeModalConfirm)="deleteCartModalActive = false">
</app-modal-confirm>
<app-modal-confirm
    [type]="iconType.WARNING"
    [showModalConfirm]="showCartSwitchDecisionModal"
    [modalTitle]="'mini-cart.cart-switch-decision-title' | translate"
    [notifyText]="'mini-cart.cart-switch-decision-msg' | translate"
    [primaryBtnText]="'mini-cart.cart-switch-decision-btn-current-cart' | translate"
    [secondaryBtnText]="'mini-cart.cart-switch-decision-btn-new-cart' | translate"
    (primaryActionConfirm)="stayOnCurrentCart()"
    (secondaryActionConfirm)="switchToNewCart()"
    (closeModalConfirm)="stayOnCurrentCart()">
</app-modal-confirm>
